import { HttpClient } from '@angular/common/http';
import { Injectable, inject, isDevMode } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { Agreement, Project } from '../schemas';
import { Auth } from './auth';
import { Lambda } from './lambda';

const reservationRecipient = isDevMode() ? 'sergey.motornyuk@linkdigital.com.au' : 'joel.wigley@linkdigital.com.au';
const expiredRecipient = isDevMode() ? 'sergey.motornyuk@linkdigital.com.au' : 'joel.wigley@linkdigital.com.au';
const pendingRecipient = isDevMode() ? 'sergey.motornyuk@linkdigital.com.au' : 'accounts@linkdigital.com.au';

@Injectable({ providedIn: 'root' })
export class Mail {
  protected readyToInvoiceMsg = '---';

  private lambda = inject(Lambda);
  protected auth = inject(Auth);
  protected http = inject(HttpClient);

  getReadyToInvoiceMsg(): string {
    return this.readyToInvoiceMsg;
  }

  sendReservation(notes: string, agreement: string, title: string) {
    const recipient: string = window['LCM_RESERVATION_MAIL'] || reservationRecipient;
    const message = `Hi Joel,

There has been a change made to the following agreement which incicates the reservations need to be renewed

URL: https://contracts.system.links.com.au/#/app/agreements/view/${agreement}
Title: ${title}
Notes: ${notes}
Assigned by: ${this.auth.name()}
`;

    return this.sendMail(message, 'LCM: Reservation', recipient);
  }

  sendExpiredAgreement(project: Agreement) {
    const recipient: string = window['LCM_EXPIRED_AGREEMENT_MAIL'] || expiredRecipient;
    const message = `Hi Joel,

The below agreement has been marked as expired.

URL: ${window.location.origin}/#/app/agreements/view/${project.AgreementNumber}
Project: ${project.Title}
Job Number: ${project.JobNumber}
Client Code: ${project.ClientCode}
Changed by: ${this.auth.name()}`;

    return this.sendMail(message, 'LCM: Expired agreement', recipient);
  }
  sendPendingInvoice(notes: string, project: Project, type_: 'product' | 'agreement', owner: string) {
    const recipient: string = window['LCM_PENDING_INVOICE_MAIL'] || pendingRecipient;
    const message = `Hi Angela,

You've been assigned a new invoice to process.

URL: ${window.location.origin}/#/app/${type_ === 'product' ? 'products' : 'agreements'}/view/${owner}
Project: ${project ? project.Title : 'Main project'}
Notes: ${notes}
Assigned by: ${this.auth.name()}`;

    return this.sendMail(message, 'LCM: Pending invoice', recipient);
  }
  sendMail(message: string, subject: string, receiver: string) {
    const data = {
      message,
      subject,
      receiver,
    };
    return firstValueFrom(this.http.post(this.lambda.getMailUrl(), data, {}));
  }
}
